module.exports = __webpack_public_path__ + "media/components/country-flag/static/tg-2ecf4a7334b8aa1fed6293d21ee84a9b.svg";